import Select from "../../../../../../components/shared/inputs/Select";

interface ColumnSelectProps {
    value?: string;
    onChange?: (value?: string) => void;
    columns: string[];
    className?: string;
    disabled?: boolean;
}

function ColumnSelect({ value, onChange, columns, className, disabled }: ColumnSelectProps) {
    return (
        <Select
            className={className}
            value={value}
            onChange={onChange}
            showSearch
            allowClear
            disabled={disabled}
        >
            {columns.map((column, index) => (
                <Select.Item key={[column, index].join()} value={column}>
                    {column}
                </Select.Item>
            ))}
        </Select>
    );
}

export default ColumnSelect;
